import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import React from "react";

interface ShopInfoColumnProps {
    shopId: number;
}

const ShopInfoColumn: React.FC<ShopInfoColumnProps> = function (props) {
    const { shopId } = props;

    const globalStore = useGlobalStore();

    const shop = globalStore.shopMapping.get(shopId);

    if (!shop) {
        return <td></td>;
    }

    return (
        <td>
            <span>{shop.name}</span>
        </td>
    );
};

export default observer(ShopInfoColumn);
